import React from "react";
import {PropsWithChildren} from "react";
import {reactChildrenByType} from "../lib/utils";

function Header({ children }: PropsWithChildren) {
    return <>{children}</>;
}

function Description({ children }: PropsWithChildren) {
    return <>{children}</>;
}

function Logo({ children }: PropsWithChildren) {
    return <>{children}</>;
}

// Main container component
function ListItem({ children, elementId }: PropsWithChildren & { elementId?: string }) {
    const header = reactChildrenByType(children, Header);
    const description = reactChildrenByType(children, Description);
    const logo = reactChildrenByType(children, Logo);

    return <div className={"grid grid-cols-[4rem,auto] gap-x-6 gap-y-4 max-w-2xl"} id={elementId}>
        <div className={"w-16 flex flex-col items-center justify-center"}>
            { logo }
        </div>
        <div className={"xs:hidden"}>{ /* spacer */ }</div>
        <div className={"col-span-2 xs:col-span-1 flex flex-row items-center"}>
            { header }
        </div>
        <div className={"hidden sm:block"}>{ /* spacer */ }</div>
        <div className={"col-span-2 sm:col-span-1"}>
            { description }
        </div>
    </div>;
}

ListItem.Header = Header;
ListItem.Description = Description;
ListItem.Logo = Logo;

export {ListItem};
